import BreakdownHOK from 'components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsBreakdownTab/BreakdownHOK';

const FundDetailsBreakdownCountryTable = () => {
  return <BreakdownHOK endpoint="country" titleKey="fundDetailsBreakdownCountryTitle" />;
};

export default FundDetailsBreakdownCountryTable;
